import React from 'react';
import PropTypes from "prop-types";

import { StyledGalleryWrapper } from '../styled';

const DesktopImg = ({ gallery, onOpenModalMulti }) => {
  const galleryList = gallery[0].items
  const galleryLength = galleryList.length;

  if (galleryList.length > 0) {
    const check = galleryList.length % 4 == 0;
    const b = Math.ceil(galleryList.length / 4) * 4

    if (check === false) {
      const c = b - galleryList.length;

      if (c > 0) {
        const x = [...Array(c).keys()]

        x.map(el => {
          galleryList.push({
            className: "empty"
          })
        })
      }
    }
  }
  
  return (
    <StyledGalleryWrapper 
      length={galleryLength} 
      desktopImageWidths={['100%', '49%', '32%', '24%']}
    >
      {galleryList.map(item => {

        if (item.className !== "empty") {
          const altText = item.gallery_image.alt || "";

          return (
            <img
              alt={altText}
              src={item.gallery_image.url}
              onClick={() => onOpenModalMulti(item.gallery_image.url, galleryList)}
              key={item.gallery_image.url}
            />
          ) 
        } else {
          return (
            <img
              className={item.className}
            />
          ) 
        }
      })}

    </StyledGalleryWrapper>
  );
};

DesktopImg.propTypes = {
  gallery: PropTypes.array,
  onOpenModalMulti: PropTypes.func
}

export default DesktopImg;
